export const vehicleMap = [
  {
    plVehicleType: "厢式",
    plVehicleCode: "300",
    grdVehicleCode: "002001",
  },
  {
    plVehicleType: "平板",
    plVehicleCode: "350",
    grdVehicleCode: "002007",
  },
  {
    plVehicleType: "高栏",
    plVehicleCode: "450",
    grdVehicleCode: "002024",
  },
  {
    plVehicleType: "特种运输",
    plVehicleCode: "600",
    grdVehicleCode: "002025",
  },
  {
    plVehicleType: "封闭式一体货车/客车",
    plVehicleCode: "100",
    grdVehicleCode: "002016",
  },
  {
    plVehicleType: "冷藏车",
    plVehicleCode: "900",
    grdVehicleCode: "002013",
  },
];

// 【一口价审批、指派用车、竞价用车】 审批状态
export const APPROVAL_STATE_OPTIONS = [
  { value: 0, label: "待审批" },
  { value: 1, label: "审批通过" },
  { value: 2, label: "审核驳回" },
  { value: 3, label: "已过期" },
  { value: 4, label: "已取消" },
];

// 【一口价审批、指派用车、竞价用车】 审批等级
export const APPROVAL_LEVEL_OPTIONS = [
  { value: 1, label: "省区中控" },
  { value: 2, label: "运营部负责人" },
  { value: 3, label: "总部中控" },
];
